<template>
  <div class="enable-bootstrap">
    <div class="wrapper gutter-big pt-0 pb-0">
        <div class="row">
            <div class="columns small-12">
                <div id="wb-journey" class="checkout">
                    <div class="module checkouttabs">
                        <ul id="pills-tab" role="tablist" class="nav acc-nums">
                            <li v-for="(step, index) in steps" :key="index" class="nav-item">
                                <router-link :to="'/step/' + getUrlEncodeOf(step.title)" class="nav-link" :class="$route.params.id == getUrlEncodeOf(step.title) ? 'active' : ''">
                                  <span class="d-none d-sm-none d-md-block d-lg-block d-xl-block">
                                    {{ step.title }}
                                  </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-view 
        :configuration="configuration"
        :steps="steps"
        @routeChange="routeChange" />
</div>
</template>

<script>
import router from './router/index.js';

const configuration = document.getElementById('configuration') ? JSON.parse(document.getElementById('configuration').innerHTML) : null;


export default {
  name: 'App',
  data() {
    return {
      configuration: {},
    }
  },
  mounted: function() {
    this.configuration = configuration;
    console.log("configuration", configuration);
    if(this.steps.length > 0 && this.steps[0].title) {
      this.routeChange(0);
    }
  },
  computed: {
    steps() {
      let steps = this.configuration.steps ? this.configuration.steps: [];
      steps.push({
        title: this.configuration.conclusionTitle ? this.configuration.conclusionTitle : 'Persönliche Daten',
        text: this.configuration.conclusionText ? this.configuration.conclusionText : 'Einfach das formular ausfüllen und Ihr persönliches Angebot erhalten.',
        summary: true,
        typ: 0,
      });
      steps.forEach(function(step, index) {
        step.index = index;
      });
      return steps;
    }
  },
  methods: {
    routeChange(routeIndex /* , oldRoute, */) {
      if(this.steps && this.steps.length && typeof this.steps[routeIndex] !== 'undefined' && this.steps[routeIndex].title) {
        router.push({ path: '/step/' + this.getUrlEncodeOf(this.steps[routeIndex].title)});
      }
    },
    getUrlEncodeOf(url) {
      url = url.replaceAll(' ', '-');
      // replace all lower Umlauts
      url = url.replace("ü", "ue")
                .replace("ö", "oe")
                .replace("ä", "ae")
                .replace("ß", "ss");
  
      // first replace all capital Umlauts in a non-capitalized context (e.g. Übung)
      url = url.replaceAll("Ü(?=[a-zäöüß ])", "Ue")
                .replaceAll("Ö(?=[a-zäöüß ])", "Oe")
                .replaceAll("Ä(?=[a-zäöüß ])", "Ae");
  
      // now replace all the other capital Umlauts
      url = url.replace("Ü", "UE")
                .replace("Ö", "OE")
                .replace("Ä", "AE");
      return url;
    }
  }
}
</script>